import { useRef } from 'react'

import { faEllipsisStrokeVertical } from '@fortawesome/pro-light-svg-icons/faEllipsisStrokeVertical'
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus'

import useTranslation from '@space-core/hooks/useTranslation'

import type { CommunityGroupCreateResponse } from '@space-shell/common/services/communities'
import { useGroupCommunityModal } from '@space-shell/modules/communities/groupCommunityModal/context/useGroupCommunityModal'
import { useDeleteGroupCommunityModal } from '@space-shell/modules/communities/groupDeleteCommunityModal/context/useGroupDeleteCommunityModal'

import CollapseItemActions from './collapseItemActions'
import { CollapseTitle } from './collapseTitle'
import type { ActiveCollapseProps } from './types'

export type CollapseHeaderActionProps = {
  version: string
  group: CommunityGroupCreateResponse
  handleActiveCollapse?: (isActive: ActiveCollapseProps) => void
  toggleAddCommunityModal: () => void
}

const CollapseHeaderAction = ({
  group,
  version,
  handleActiveCollapse,
  toggleAddCommunityModal
}: CollapseHeaderActionProps) => {
  const { t } = useTranslation()
  const collapseRef = useRef<HTMLDivElement>(null)
  const groupCommunityModalContext = useGroupCommunityModal()
  const groupDeleteCommunityModalContext = useDeleteGroupCommunityModal()

  const handleCreateNewGroup = () => {
    handleActiveCollapse?.('false')

    groupCommunityModalContext.setIsEditing(false)
    groupCommunityModalContext.openGroupModal(group)
  }

  const handleEditGroup = (groupToEdit: CommunityGroupCreateResponse) => {
    handleActiveCollapse?.('false')
    groupCommunityModalContext.setIsEditing(true)
    groupCommunityModalContext.openGroupModal(groupToEdit)
  }

  const handleDeleteGroup = () => {
    handleActiveCollapse?.('false')

    !isNaN(Number(group.id)) &&
      groupDeleteCommunityModalContext.openDeleteGroupModal(group.id, group.name)
  }

  const collapseHeaderCreateActions = [
    {
      callBack: () => handleCreateNewGroup(),
      label: t('buttons.add_group'),
      isVisibleItem: true
    },
    {
      callBack: () => toggleAddCommunityModal(),
      label: t('modal.create_community.save_button'),
      isVisibleItem: true
    }
  ]

  const collapseHeaderInfoActions = [
    {
      callBack: () => handleEditGroup(group),
      label: t('buttons.edit_group'),
      isVisibleItem: true
    },
    {
      callBack: () => handleDeleteGroup(),
      label: t('buttons.remove_group'),
      isVisibleItem: true
    }
  ]

  const classCollapseActions = '_border-0 _bg-transparent _outline-0'

  return (
    <div className='_d-flex' ref={collapseRef}>
      <CollapseTitle version={version}>{group.name}</CollapseTitle>
      <>
        <CollapseItemActions
          handleActiveCollapse={handleActiveCollapse}
          dropdownIcon={faPlus}
          classNames={classCollapseActions}
          actions={collapseHeaderCreateActions}
        />
        <CollapseItemActions
          handleActiveCollapse={handleActiveCollapse}
          dropdownIcon={faEllipsisStrokeVertical}
          classNames={classCollapseActions}
          actions={collapseHeaderInfoActions}
        />
      </>
    </div>
  )
}

export default CollapseHeaderAction
